import { render } from "./threePage.vue?vue&type=template&id=395bebf1&scoped=true"
import script from "./threePage.vue?vue&type=script&lang=js"
export * from "./threePage.vue?vue&type=script&lang=js"

import "./threePage.vue?vue&type=style&index=0&id=395bebf1&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-395bebf1"]])

export default __exports__